module.exports = __webpack_public_path__ + "media/WR Blob 11.be9e8512.mp3";